// extracted by mini-css-extract-plugin
export default {"tracker":"Tracker_tracker__8mgyQ","section":"Tracker_section__HvO3F","fullSize":"Tracker_fullSize__SVAH7","header":"Tracker_header__m3CAT","list":"Tracker_list__4jott"};